import { UNSENT_EMAILS, type EmailTemplateKey, type EmailTemplateView } from '@jfh/intake-shared';

/** Applicant email wording for Settings → Applicant emails (F10 P5). */

export const unsent = (key: string) => UNSENT_EMAILS.includes(key as EmailTemplateKey);

/** "Sent · built-in wording" / "Sent · your wording" / "Switched off" / "Not sent yet". */
export function emailState(t: Pick<EmailTemplateView, 'key' | 'enabled' | 'edited'>): { label: string; bad: boolean } {
  if (unsent(t.key)) return { label: 'Not sent yet', bad: true };
  if (!t.enabled) return { label: 'Switched off', bad: true };
  return { label: t.edited ? 'Sent · your wording' : 'Sent · built-in wording', bad: false };
}

/** "Sent: when Customer Service approves …" from the API's `when` sentence. */
export const sentWhen = (when: string) => `Sent: ${when.charAt(0).toLowerCase()}${when.slice(1)}`;
